import _pullAll from "lodash/pullAll";
import produce from 'immer';
import initialState from './initialState';
var samplesDelete = produce(function (draft, action) {
  var _action$payload = action.payload,
    experimentId = _action$payload.experimentId,
    sampleIds = _action$payload.sampleIds;
  _pullAll(draft[experimentId].sampleIds, sampleIds);
}, initialState);
export default samplesDelete;